// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Logout from '../_raw/ui/icon_logout.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Logout);
